import React, { memo, ReactNode, useEffect, useMemo, useRef, useState } from "react"
import {Button, Container, Flex, Heading, Spinner, Table, Text} from '@radix-ui/themes'
import useFetch from '../../core/hooks/useFetch'
import CbrService from '../../core/services/CbrService'
import { ICbrRatesGosbank, ICbrRatesMetals } from "../../core/types/services-types/cbr-types"
import AppTable from '../../components/controls/tables/AppTable'
import moment from "moment"
import useObserver from '../../hooks/useObserver'
import {CellComponentProps, Grid} from "react-window";

export default function Currencies() {
    const [ratesGosbank, setRatesGosbank] = useState<ICbrRatesGosbank[]>([])
    const [ratesMetals, setRatesMetals] = useState<ICbrRatesMetals[]>([])
    const [ratesMetalsPage, setRatesMetalsPage] = useState<number>(0)
    const [memoRatesMetals, setMemoRatesMetals] = useState<ICbrRatesMetals[]>([])
    const [currentState, setCurrentState] = useState<'sssr' | 'metals'>('sssr')
    const bottomMetals = useRef<HTMLDivElement>(null)
    const [ratesGosbankHeadersTableFormat, setRatesGosbankHeadersTableFormat] = useState<any[]>([
            "Единиц",
            "Валюта",
            "Курс",
            "Дата"
        ])
    const [ratesGosbankTableFormat, setRatesGosbankTableFormat] = useState<any[][]>([])
    const [ratesMetalsHeadersTableFormat, setRatesMetalsHeadersTableFormat] = useState<any[]>([
        "Золото",
        "Дата"
    ])
    const [ratesMetalsTableFormat, setRatesMetalsTableFormat] = useState<any[][]>([])

    const [fetchRatesGosbank, isLoadingRatesGosbank, errorRatesGosbank, errorsRatesGosbank] = useFetch(async () => {
        const data = await CbrService.GetGosbankRates()
        setRatesGosbank(data)
        data.forEach(item => {
            setRatesGosbankTableFormat(prev => prev.concat([Object.entries(item)]))
        })
        
    })


    const paginationRatesMetals = (nulled: boolean = false) => {
        if(nulled) {
            setMemoRatesMetals([])
            setRatesMetalsPage(0)
            setRatesMetalsTableFormat([])
        }
        const startIndex = ratesMetalsPage * 100
        const endIndex = startIndex + 100
        setMemoRatesMetals(ratesMetals.slice(startIndex, endIndex))
        console.log(memoRatesMetals)
        memoRatesMetals.forEach(item => {
            setRatesMetalsTableFormat(prev => prev.concat([Object.entries(item)]))
        })
    }

    const renderOptionGosbankRates = (key: string, value: string) => {
        if(key === 'date') {
            return ( 
             <Table.Cell>
            { moment(value).format("DD.MM.YYYY")}
             </Table.Cell>
            )
        }
        return <Table.Cell>{value}</Table.Cell>
    }


function CellComponent({
  ratesMetals,
  columnIndex,
  rowIndex,
  style
}: CellComponentProps<{
  ratesMetals: ICbrRatesMetals[];
}>) {

   
    const row = Object.entries(ratesMetals[rowIndex]);
    console.log(row)
    const content = row[columnIndex][1];
 
  return (
    <div className="truncate" style={style}>
      {content}
    </div>
  );
}

    const [fetchRatesMetals, isLoadingRateMetals, errorRatesMetals, errorsRatesMetals] = useFetch(async () => {
        const data = await CbrService.GetMetalsRates()
        setRatesMetals(data)
      
        paginationRatesMetals(true)
    })
    useEffect(() => {
        if(currentState === 'sssr' && !ratesGosbank.length) {
            fetchRatesGosbank()
        }  
        else if(currentState === 'metals') {
             
        if(!ratesMetals.length) {
            fetchRatesMetals()
        }
        else {
            paginationRatesMetals(true)
        }
    }
        
    }, [currentState])

    useEffect(() => {
        if(ratesMetalsPage === 0) return
        
        paginationRatesMetals()
    }, [ratesMetalsPage])

    useObserver({
        ref: bottomMetals,
        canLoad: memoRatesMetals.length < ratesMetals.length,
        isLoading: isLoadingRateMetals,
        callback: () => setRatesMetalsPage(prev => prev + 1)
    })

    return (
        <Container className="mt-5">
             
            <Container>
            <Flex className="shadow-lg p-10 bg-zinc-50 rounded-lg" justify={'between'} wrap={'wrap'} gap={'5'}> 
            <Heading>
             {currentState === 'sssr' ? "Официальные курсы Госбанка СССР иностранных валют по отношению к рублю, применяемые в платежно-расчетных отношениях Российской Федерации с иностранными государствами по торговым и кредитным соглашениям бывшего СССР" : "Учетные цены на аффинированные драгоценные металлы"}
            </Heading>
            <Flex gap={'5'} wrap={'wrap'}> 
            <Button disabled={currentState === 'sssr'} onClick={() => setCurrentState('sssr')}>
                Курсы СССР
            </Button>
            <Button disabled={currentState === 'metals'} onClick={() => setCurrentState('metals')}>
                Курсы драгоценных металлов
            </Button>
            </Flex>
            </Flex>
            <Container className="p-10 shadow-lg bg-zinc-50 rounded-lg mt-10">
                {(isLoadingRateMetals || isLoadingRatesGosbank) && <Spinner />}
                {currentState === 'sssr' ?
                <Flex direction={'column'}> 
                <AppTable 
                    headers={ratesGosbankHeadersTableFormat}
                    data={ratesGosbankTableFormat}
                    renderOption={renderOptionGosbankRates}
                />
                </Flex>
                :
                <Flex direction={'column'} align={'center'} justify={'center'}> 
                <Grid 
                cellComponent={CellComponent}
                cellProps={{ratesMetals}}
                columnCount={3}
                columnWidth={200}
                rowCount={ratesMetalsTableFormat.length}
                rowHeight={25}
                />
               
            <div className="bottom-metals" ref={bottomMetals}></div>
            </Flex>
                }
            </Container>
            </Container>

        </Container>
    )
}